export const PAGE = {
  Home: 'landingspagina',
  ProductWizard: 'funnelpagina',
  Modal: 'pop-up',
  ProductInformation: 'productinfo',
} as const;
